import React from "react";
import { Card, Spin, Empty, Table, Tag } from "antd";

// Simple timeline visualization using a table with colored bars
// For a full chart, consider installing @ant-design/charts

const TimelineChart = ({ timeline, loading }) => {
  if (loading) {
    return (
      <Card title="Eventos ao Longo do Tempo">
        <div style={{ textAlign: "center", padding: "40px" }}>
          <Spin size="large" />
        </div>
      </Card>
    );
  }

  if (!timeline?.data || timeline.data.length === 0) {
    return (
      <Card title="Eventos ao Longo do Tempo">
        <Empty description="Nenhum dado disponivel para o periodo selecionado" />
      </Card>
    );
  }

  const maxValue = Math.max(
    ...timeline.data.map((d) =>
      Math.max(d.send || 0, d.delivery || 0, d.open || 0, d.click || 0)
    )
  );

  const renderBar = (value, color, max) => {
    const width = max > 0 ? (value / max) * 100 : 0;
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <div
          style={{
            width: `${Math.max(width, 2)}%`,
            minWidth: value > 0 ? "4px" : "0",
            maxWidth: "100%",
            height: "16px",
            backgroundColor: color,
            borderRadius: "2px",
            transition: "width 0.3s ease",
          }}
        />
        <span style={{ fontSize: 12, color: "#666", minWidth: 30 }}>
          {value}
        </span>
      </div>
    );
  };

  const columns = [
    {
      title: "Data",
      dataIndex: "date",
      key: "date",
      width: 100,
      fixed: "left",
    },
    {
      title: (
        <span>
          <Tag color="blue">Enviados</Tag>
        </span>
      ),
      dataIndex: "send",
      key: "send",
      render: (val) => renderBar(val || 0, "#1890ff", maxValue),
    },
    {
      title: (
        <span>
          <Tag color="green">Entregues</Tag>
        </span>
      ),
      dataIndex: "delivery",
      key: "delivery",
      render: (val) => renderBar(val || 0, "#52c41a", maxValue),
    },
    {
      title: (
        <span>
          <Tag color="cyan">Abertos</Tag>
        </span>
      ),
      dataIndex: "open",
      key: "open",
      render: (val) => renderBar(val || 0, "#13c2c2", maxValue),
    },
    {
      title: (
        <span>
          <Tag color="purple">Cliques</Tag>
        </span>
      ),
      dataIndex: "click",
      key: "click",
      render: (val) => renderBar(val || 0, "#722ed1", maxValue),
    },
    {
      title: (
        <span>
          <Tag color="orange">Bounces</Tag>
        </span>
      ),
      dataIndex: "bounce",
      key: "bounce",
      render: (val) => renderBar(val || 0, "#fa8c16", maxValue),
    },
  ];

  return (
    <Card
      title="Eventos ao Longo do Tempo"
      extra={
        <span style={{ color: "#888", fontSize: 12 }}>
          {timeline.startDate} a {timeline.endDate} (por {timeline.groupBy})
        </span>
      }
    >
      <Table
        columns={columns}
        dataSource={timeline.data}
        rowKey="date"
        pagination={false}
        size="small"
        scroll={{ x: 800 }}
      />
    </Card>
  );
};

export default TimelineChart;
